module.exports = __webpack_public_path__ + "media/images/tailwind/icon-mailer-71d88847c771612fed22d4230f9cbecf.png";